import { memo } from "react";

import TableSimple from "ds/components/TableSimple";
import useTypedContext from "hooks/useTypedContext";
import { TemplateDeployment } from "types/generated";
import { TemplateContext } from "views/Account/Template/Context";

import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { TEMPLATE_DEPLOYMENTS_TABLE_CELLS } from "./Cells";
import { TEMPLATE_DEPLOYMENTS_SORT_CONFIG } from "./constants";
import {
  useTemplateDeploymentsTableStore,
  useTemplateDeploymentsMarketplaceTableStore,
} from "./useTemplateDeploymentsTableStore";

type DeploymentsTableProps = {
  deployments: TemplateDeployment[];
  loading?: boolean;
  rowsPerPage: number;
};

const DeploymentsTable = ({ deployments, loading, rowsPerPage }: DeploymentsTableProps) => {
  const { isMarketplace } = useTypedContext(TemplateContext);

  const commonProps = {
    data: deployments,
    loading,
    ariaLabel: "Deployments table",
    rowsPerPage,
    filtersStorageKey: FILTERS_ORDER_SETTINGS_KEY,
    cellPerColumn: TEMPLATE_DEPLOYMENTS_TABLE_CELLS,
    sortConfig: TEMPLATE_DEPLOYMENTS_SORT_CONFIG,
    hasPagination: true,
  };

  if (isMarketplace) {
    return <TableSimple {...commonProps} store={useTemplateDeploymentsMarketplaceTableStore} />;
  }

  return <TableSimple {...commonProps} store={useTemplateDeploymentsTableStore} />;
};

export default memo(DeploymentsTable);
